import React from "react";
import styles from "./styles.module.scss";
import { getInitialsFromNames } from "@intelligentlilli/lilli-utils";
// Components
import Card from "../Card";
import ServiceUserImage from "../ServiceUserImage";
// Utils
import {
  getIsUserJustAnInstaller,
  getUserHasInstallerRole,
  getUserRoleAsString,
} from "../../Services/Utils";

const StaffCard = ({ staffMember, onClick }) => {
  const staffName =
    staffMember?.forenames && staffMember?.surname
      ? staffMember?.forenames + " " + staffMember?.surname
      : staffMember?.email;
  const staffRoles = staffMember?.roles;
  const staffRoleAsString = getUserRoleAsString(staffRoles);
  const staffHasInstallerRole = getUserHasInstallerRole(staffRoles);
  const staffIsJustAnInstaller = getIsUserJustAnInstaller(staffRoles);
  const displayStaffRole = staffIsJustAnInstaller
    ? "Installer"
    : `${staffRoleAsString}${staffHasInstallerRole ? " & Installer" : ""}`;
  // Don't show the inactive hubs, i.e. "active: 0" as these will be excluded
  // from the list of service users that we see on the Staff Member page
  const activeHubs = staffMember?.hubs?.filter((hub) => hub.active !== 0);

  return (
    <Card onClick={onClick} variant="outlined" style={styles.card}>
      <div className={styles.card_top} data-private>
        <ServiceUserImage
          medium
          staff
          initials={getInitialsFromNames(
            staffMember?.forenames,
            staffMember?.surname
          )}
          profilePhotoURL={staffMember.photo}
        />
        <div className={styles.card_right}>
          <div className={styles.card_right_name}>{staffName}</div>
          <div>{displayStaffRole}</div>
          <div className={styles.bold}>
            {activeHubs?.length} service user
            {activeHubs?.length === 1 ? "" : "s"}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default StaffCard;
